﻿interface QuizQuestion {
    questionId: number;
    question: string;
    answerOptions: string[];
    correctAnswerId: number;
    explanation: string;
}

export class Quiz {
    private quizQuestions: QuizQuestion[];

    private questionId: number;
    private answers: number[] = [];

    private pageElement: HTMLElement;
    private questionNumberElement: HTMLElement;
    private questionTextElement: HTMLElement;
    private answersElement: HTMLElement;
    private explanationTextElement: HTMLElement;
    private correctQuestionCountElement: HTMLElement;
    private correctQuestionPercentageElement: HTMLElement;

    get correctQuestionCount(): number {
        return this.quizQuestions.filter((q, index) => {
            return this.answers[index] === q.correctAnswerId;
        }).length;
    }

    constructor() {
        const quizQuestionsElement: HTMLInputElement = document.getElementById('quiz-questions') as HTMLInputElement;
        this.pageElement = document.querySelector('.page--quiz') as HTMLElement;
        this.questionNumberElement = document.querySelector('#questionNumber') as HTMLElement;
        this.questionTextElement = document.querySelector('.question--text') as HTMLElement;
        this.answersElement = document.querySelector('.answers') as HTMLElement;
        this.explanationTextElement = document.querySelector('.explanation--text') as HTMLElement;
        this.correctQuestionCountElement = document.querySelector('#correctQuestionCount') as HTMLElement;
        this.correctQuestionPercentageElement = document.querySelector('#correctQuestionPercentage') as HTMLElement;
        if (!quizQuestionsElement || !this.pageElement || !this.questionNumberElement || !this.questionTextElement
            || !this.answersElement || !this.explanationTextElement || !this.correctQuestionCountElement || !this.correctQuestionPercentageElement) {
            console.error("Some quiz elements missing.");
            return;
        }

        this.quizQuestions = JSON.parse(quizQuestionsElement.value);
        console.log("This is the firts question: ", this.quizQuestions[0].question);

        this.questionId = 0;
        this.initializeQuestion();
    }

    private initializeQuestion = () => {
        const initializeAnswerElement = (answerIndex) => {
            this.answersElement.children[answerIndex].classList.remove('selected');
            this.answersElement.children[answerIndex].classList.remove('correct');
            this.answersElement.children[answerIndex].classList.remove('incorrect');
            this.answersElement.children[answerIndex].children[0].innerHTML = this.quizQuestions[this.questionId].answerOptions[answerIndex];
            this.answersElement.children[answerIndex].classList.add(this.quizQuestions[this.questionId].correctAnswerId === answerIndex ? 'correct' : 'incorrect');
        }

        this.pageElement.classList.remove('question-answered');
        this.pageElement.classList.remove('question-first');
        this.pageElement.classList.remove('quiz-results');
        if (this.questionId === 0) {
            this.pageElement.classList.add('question-first');
        }
        this.questionNumberElement.innerHTML = (this.questionId + 1) + '';
        this.questionTextElement.innerHTML = this.quizQuestions[this.questionId].question;
        initializeAnswerElement(0);
        initializeAnswerElement(1);
        initializeAnswerElement(2);
        this.explanationTextElement.innerHTML = this.quizQuestions[this.questionId].explanation;
        if (this.answers.length > this.questionId) {
            this.pageElement.classList.add('question-answered');
            this.answersElement.children[this.answers[this.questionId]].classList.add('selected');
        }
    }

    private initializeQuizResults = () => {
        this.pageElement.classList.add('quiz-results');
        this.correctQuestionCountElement.innerHTML = this.correctQuestionCount + '';
        this.correctQuestionPercentageElement.innerHTML = Math.round(100 * this.correctQuestionCount / this.quizQuestions.length) + '%';
    }

    public answer = (answerIndex) => {
        if (this.answers.length > this.questionId) {
            console.log("Question ID " + this.questionId + " already answered.");
            return;
        }

        this.answers.push(answerIndex);
        console.log("Question ID " + this.questionId + " answered with answer index " + answerIndex);
        this.initializeQuestion();
    }

    public next = () => {
        if (this.answers.length < this.questionId || this.quizQuestions.length <= this.questionId) {
            return;
        }
        this.questionId = this.questionId + 1;
        if (this.quizQuestions.length === this.questionId) {
            this.initializeQuizResults();
            return;
        }
        this.initializeQuestion();
    }

    public previous = () => {
        if (this.questionId <= 0) {
            return;
        }
        this.questionId = this.questionId - 1;
        this.initializeQuestion();
    }
}

window['quiz'] = new Quiz();
window['bootstrap'] = require('bootstrap');
